export default [
  { value: 'US', label: 'United States' },
  { value: 'CA', label: 'Canada' },
  // { value: 'AU', label: 'Australia' },
  { value: 'UK', label: 'United Kingdom' },
]
